import { Item } from '../../models/Item'
import { Line } from '../../models/Line'
import { Icon, IconNameAndCategoryString } from '../Icon'
import Avatar from '../app/design/Avatar'
import Label from '../app/design/Label'
import Paragraph from '../app/design/Paragraph'
import Tooltip from '../app/design/Tooltip'

type LineItemDisplayDetails = {
    name: string
    imageUri?: string
    id: string
}

const extractLineItemDisplayDetails = (li: Line | Item): LineItemDisplayDetails => {
    if (li instanceof Item) {
        return {
            name: li.name ?? '',
            imageUri: li.image?.uri,
            id: li.id ?? '',
        }
    }

    return {
        name: li.itemDisplay ?? '',
        imageUri: li.item?.image?.uri,
        id: li.id ?? '',
    }
}

type Props = {
    services: (Item | Line)[]
    icon?: IconNameAndCategoryString
}

export function ServiceListTableCell({ services, icon }: Props) {
    if (!services.length) return <Paragraph size="sm">-</Paragraph>

    const displayDetails = services.map((s) => extractLineItemDisplayDetails(s))

    if (displayDetails.length === 1) {
        const s = displayDetails[0]
        return (
            <div className="flex items-center gap-3">
                {s.imageUri ? (
                    <Avatar size="xs" className="flex-shrink-0 overflow-clip">
                        <img src={s.imageUri} className="size-full object-cover" />
                    </Avatar>
                ) : (
                    <Icon background="round" icon={icon ?? 'tag.small'} className="size-6" />
                )}

                <Paragraph size="sm">{s.name}</Paragraph>
            </div>
        )
    }

    if (displayDetails.length <= 3) {
        return (
            <div className="flex items-center gap-3">
                {displayDetails.map((s) => {
                    return (
                        <Tooltip key={s.id} label={s.name ?? ''} position="top" wrap>
                            {s.imageUri ? (
                                <Avatar size="xs" className="flex-shrink-0 overflow-clip">
                                    <img src={s.imageUri} className="size-full object-cover" />
                                </Avatar>
                            ) : (
                                <Icon
                                    background="round"
                                    icon={icon ?? 'tag.small'}
                                    className="size-6"
                                />
                            )}
                        </Tooltip>
                    )
                })}
                <Paragraph size="sm">{`${displayDetails.length} services`}</Paragraph>
            </div>
        )
    }

    return (
        <div className="flex items-center gap-3">
            {displayDetails.slice(0, 2).map((s) => {
                return (
                    <Tooltip key={s.id} label={s.name ?? ''} position="top" wrap>
                        {s.imageUri ? (
                            <Avatar size="xs" className="flex-shrink-0 overflow-clip">
                                <img
                                    src={s.imageUri}
                                    className="size-full flex-shrink-0 object-cover"
                                />
                            </Avatar>
                        ) : (
                            <Icon
                                background="round"
                                icon={icon ?? 'tag.small'}
                                className="size-6"
                            />
                        )}
                    </Tooltip>
                )
            })}
            <Tooltip
                label={displayDetails.slice(2).map((s) => (
                    <Paragraph size="sm">{s.name}</Paragraph>
                ))}
                position="top"
                wrap
            >
                <Avatar size="xs">
                    <Label size="xs">{`+${displayDetails.length - 2}`}</Label>
                </Avatar>
            </Tooltip>
            <Paragraph size="sm">{`${displayDetails.length} services`}</Paragraph>
        </div>
    )
}
